import type { TPeriodicidadePagamentoEnum } from '@/types/simulacao'
import type { TGrupoParcelas } from '@/utils/calculadora-valores-totais/processador-valores-decimal'
import { extractDateOnly } from '@/utils/date.utils'
import {
  transformEntradasFromApi,
  transformIntermediariasFromApi,
  transformMensaisFromApi,
  transformPosConclusaoFromApi,
} from '@/utils/grupo-parcelas-transformers'
import type { TGrupoParcelasToUTC } from '@/utils/grupo-parcelas.utils'

export type TGrupoParcelasIntermediarias = TGrupoParcelasToUTC & { periodicidade: TPeriodicidadePagamentoEnum }

export class GruposParcelasApiMapper {
  constructor(
    private readonly simulacao: {
      entrada: TGrupoParcelas
      mensais: TGrupoParcelasToUTC[]
      intermediarias: TGrupoParcelasIntermediarias[]
      saldo?: TGrupoParcelasToUTC['parcelas'][number] | null
      posConclusao: TGrupoParcelasToUTC['parcelas']
      intermediariasPosConclusao?: TGrupoParcelasIntermediarias[] | null
    },
  ) {}

  public buildGruposParcelas() {
    return {
      entradas: transformEntradasFromApi(this.simulacao.entrada),
      mensais: transformMensaisFromApi(this.simulacao.mensais),
      intermediarias: transformIntermediariasFromApi(this.simulacao.intermediarias),
      saldo: this.mapSaldo(),
      posConclusao: transformPosConclusaoFromApi(this.simulacao.posConclusao),
      intermediariasPosConclusao: this.mapIntermediariasPosConclusao(),
    }
  }

  private mapIntermediariasPosConclusao() {
    return this.simulacao?.intermediariasPosConclusao
      ? transformIntermediariasFromApi(this.simulacao.intermediariasPosConclusao)
      : undefined
  }

  private mapSaldo() {
    return this.simulacao.saldo
      ? {
          data: extractDateOnly(this.simulacao.saldo?.data),
          valor: this.simulacao.saldo?.valor ?? 0,
        }
      : null
  }
}
